import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { applicationContext } from "helpers/services";

interface IToolTypologiesContext {
    recordCount: number
    search: ISearchRequest
    toolTypologies: IToolTypology[]
    isLoading: boolean

    doSearch: (search: ISearchRequest) => void
    handleChangePage: (page: number) => void
    searchToolTypologies: (searchRequest: ISearchRequest) => Promise<void>
    deleteToolTypology: (toolTypologyId: string) => Promise<void>
    handleChange: (e: any) => void
}

export interface IToolTypology {
    toolTypologyId: string
    name: string
    needMaintenance: boolean
    notes: string
}

interface ISearchRequest {
    searchText: string
    pageNr: number
    pageSize: number
}

export let toolTypologiesContext = React.createContext({} as IToolTypologiesContext);

let { Provider } = toolTypologiesContext;

let ToolTypologiesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { enqueueSnackbar } = useSnackbar();
    let history = useHistory();
    let location = useLocation();

    let appService = useContext(applicationContext);

    let [isLoading, setLoading] = useState(true);

    let [toolTypologies, setToolTypologies] = useState<IToolTypology[]>([]);
    let [recordCount, setTotalRecords] = useState(0);

    let [search, setSearch] = useState<ISearchRequest>({
        searchText: '',
        pageNr: 0,
        pageSize: 15
    });

    useEffect(() => {
        if (location.state)
            processState(location.state);
    }, [location.state])

    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        if (state.search) {
            setSearch(state.search);
            searchToolTypologies(state.search);
        }
    }

    let doSearch = (values: ISearchRequest) => {
        let request = {
            ...values,
            pageNr: values.pageNr > 0 ? 0 : values.pageNr
        }

        history.push(location.pathname, {
            search: request,
            selectedToolTypologies: [],
            allPageSelected: false
        });
    }

    let searchToolTypologies = async (searchRequest: ISearchRequest) => {
        try {
            setLoading(true);
            let response = await axios.post('/api/Tool/SearchToolTypologies', searchRequest);
            setToolTypologies(response.data.items);
            setTotalRecords(response.data.recordCount);
        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let handleChangePage = (page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        history.push(location.pathname, {
            search: request,
            selectedToolTypologies: [],
            allPageSelected: false
        });
    }

    let deleteToolTypology = async (toolTypologyId: string) => {
        if (window.confirm("Vuoi eliminare questa Topologia?")) {
            try {
                await axios.delete(`/api/Tool/DeleteToolTypology/${toolTypologyId}`)
                setToolTypologies(toolTypologies.filter(toolTypology => toolTypology.toolTypologyId !== toolTypologyId));
                setTotalRecords(recordCount - 1);
                await appService.getSimecReferenceData();
                enqueueSnackbar("ToolTypology deleted", { variant: 'success' });
            } catch (error) { }
        }
    }

    let handleChange = (e: any) => {
        let request = {
            ...e
        };
        setSearch(request);
    }

    return (
        <Provider value={{
            recordCount,
            search,
            toolTypologies,
            isLoading,

            doSearch,
            handleChangePage,
            searchToolTypologies,
            deleteToolTypology,
            handleChange
        }}>
            {children}
        </Provider>
    );
};

export default ToolTypologiesProvider;